import Action from "../base/action";

class Selection extends Action {
    models;
    volumes;
    branches;
    groups;
    enabled;

    constructor(props) {
        super(props);
        this.models = props.models || [];
        this.volumes = props.volumes || [];
        this.branches = props.branches || [];
        this.groups = props.groups || [];
        this.enabled = !isNullOrUndefined(props.enabled) ? props.enabled : true;
    }

    async execute() {
        throw new Error("subclass responsibility");
    }

}

export default Selection;
